import { createApp } from 'vue';
import '../scss/graphics/HomeIcons.scss';
import cmpFaq from '../vue/common/Faq.vue';
import cmpProductCards from '../vue/common/ProductCards.vue';

window.FrontPage = (function() {
	// search event
	const initSearch = () => {
		const searchInput = document.getElementById('search-input');
		const searchButton = document.getElementById('search-button');

		const navigateToSearch = (event) => {
			event.preventDefault();

			const searchTerm = encodeURIComponent(searchInput.value.trim());
			if (searchTerm) {
				const url = `/bundles/term/${searchTerm}/`;
				window.open(url, '_blank');
			}
		};

		searchInput.addEventListener('keydown', (event) => {
			if (event.key === 'Enter') {
				navigateToSearch(event);
			}
		});

		searchButton.addEventListener('click', navigateToSearch);
	};


	// product cards - new
	const initProductCardsNew = () => {
		const component = createApp(cmpProductCards, {
			headerName : 'New',
			buttonUrl : '/bundles/',
			oBundles  : window.frontPageInfo.bundlesNew
		});

		return component.mount('#component-product-cards-new');
	};


	// product cards - bestsellers
	const initProductCardsBest = () => {
		const component = createApp(cmpProductCards, {
			headerName : 'Bestsellers',
			buttonUrl : '/bundles/',
			oBundles  : window.frontPageInfo.bundlesBest
		});

		return component.mount('#component-product-cards-best');
	};


	// product cards - sale
	const initProductCardsSale = () => {
		const component = createApp(cmpProductCards, {
			headerName : 'Sale',
			buttonUrl : '/bundles/',
			oBundles  : window.frontPageInfo.bundlesSale
		});

		return component.mount('#component-product-cards-sale');
	};


	// faq
	const initFaq = () => {
		const component = createApp(cmpFaq, {
			popupMode: false
		});

		return component.mount('#component-faq');
	};


	// init search event
	document.addEventListener('DOMContentLoaded', initSearch);

	// init vue components
	let retValue = {
		cmpProductCardsNew : initProductCardsNew(),
		cmpProductCardsBest : initProductCardsBest(),
		cmpProductCardsSale : initProductCardsSale(),
		cmpFaq : initFaq()
	};

	// delete variable from window
	delete window.frontPageInfo;

	// return
	return retValue;
})();
